module.exports = __webpack_public_path__ + "img/transferencia_bancaria.5f152617.svg";